(() => {
  const ROOT_SELECTOR = '[data-payments-root]';

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    return fallbackCopy(text);
  };

  const initCopy = (root) => {
    root.querySelectorAll('[data-payments-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const source = document.getElementById(button.dataset.copyTarget);
        const status = document.getElementById(button.dataset.copyStatus);

        if (!source || !status) return;

        try {
          const copied = await copyText(source.textContent.replace(/\s+/g, ' ').trim());
          status.textContent = copied
            ? 'Numer rachunku został skopiowany.'
            : 'Nie udało się skopiować numeru. Skopiuj go ręcznie.';
        } catch (error) {
          status.textContent = 'Nie udało się skopiować numeru. Skopiuj go ręcznie.';
          console.error('Payments copy error:', error);
        }

        window.setTimeout(() => {
          status.textContent = '';
        }, 4000);
      });
    });
  };

  const initChat = (root) => {
    const button = root.querySelector('[data-payments-chat]');
    if (!button) return;

    button.addEventListener('click', () => {
      const trigger = document.getElementById('Avada-FAQ_WidgetTrigger');

      if (trigger) {
        trigger.click();
        return;
      }

      window.setTimeout(() => {
        document.getElementById('Avada-FAQ_WidgetTrigger')?.click();
      }, 500);
    });
  };

  const init = (root) => {
    if (!root || root.dataset.paymentsInitialized === 'true') return;

    initCopy(root);
    initChat(root);
    root.dataset.paymentsInitialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector(ROOT_SELECTOR));
  });
})();
